import {ReactNode} from "react";
import {Card, Image, Text} from "@mantine/core";

interface CustomCardProps {
  label?: string
  image?: string
  children?: ReactNode
}

export function CustomCard({label, image, children}: CustomCardProps) {
  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder>
      {image && <Image src={image} mb="md"/>}

      {label && (
        <Text fw={500} size="lg" ta="left">
          {label}
        </Text>
      )}

      {children}
    </Card>
  )
}

